import React from 'react';

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

function WarningExistingExperienceItems({ open, onClose, onConfirm }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle fontSize={24} fontWeight="bold">
        Warning
      </DialogTitle>
      <DialogContent sx={{ minWidth: '400px' }}>
        <DialogContentText>
          <Alert severity="error" sx={{ paddingY: 0 }} icon={false}>
            <Typography component="span" fontSize={20} fontWeight="bold" color="red">
              This order has some experiences items. Please check them below and cancel to prevent partial
              cancellations.
            </Typography>
          </Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          I understand
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WarningExistingExperienceItems;
